module.exports = {
  'font-face': require('./font-face'),
  'import': require('./import'),
  'media': require('./media'),
  'page': require('./page'),
  'supports': require('./supports')
};